<header class="pb-3 mb-5">
  <h2>Bienvenue sur</h2>
  <h1>Société Parc-Auto du Québec</h1>
</header>




// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/layout/components/layout-auth-header/layout-auth-header.component.html